/* Query actions stay in the overlay; product and collection links keep their destinations. */
(() => {
 const showQuery = (modal, value) => {
  const input = modal.querySelector('input[name="q"]');
  if (!input) return;
  input.value = value.trim();
  input.dispatchEvent(new Event('input', {bubbles:true}));
  input.focus({preventScroll:true});
 };
 document.addEventListener('submit', event => {
  const form = event.target.closest?.('.search-modal form[role="search"]');
  if (!form) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  showQuery(form.closest('.search-modal'), form.querySelector('[name="q"]')?.value || '');
 }, true);
 document.addEventListener('click', event => {
  const link = event.target.closest?.('.search-modal a[href]');
  if (!link) return;
  const url = new URL(link.href, location.origin);
  if (url.origin !== location.origin || !/^\/search\/?$/.test(url.pathname) || !url.searchParams.has('q')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  showQuery(link.closest('.search-modal'), url.searchParams.get('q') || '');
 }, true);
 const hydrate = modal => {
  modal.querySelectorAll('.product-card__mobile-media-dots').forEach(group => {
   const dots = [...group.querySelectorAll('[data-product-card-media-dot]')];
   if (!dots.length) return;
   const frame = group.closest('[data-product-card-media-slider]');
   const index = Number(frame?.dataset.productCardMediaIndex || 0);
   dots.forEach((dot, i) => {
    dot.classList.toggle('is-active', i === index);
    dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    dot.tabIndex = 0;
   });
  });
  window.ValoraieHydrateProductCards?.(modal);
 };
 let pending = false;
 const observer = new MutationObserver(records => {
  if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('.predictive-search__product-card,.search-modal__product-card') || n.querySelector?.('.predictive-search__product-card,.search-modal__product-card'))))) return;
  if (pending) return;
  pending = true;
  requestAnimationFrame(() => {pending=false; document.querySelectorAll('.search-modal').forEach(hydrate);});
 });
 document.querySelectorAll('.search-modal').forEach(modal => {
  observer.observe(modal,{childList:true,subtree:true});
 });
})();
(() => {
 const states = new WeakMap();
 const setup = modal => {
  const list = modal.querySelector('#predictive-search-results-products-list');
  if (!list || states.has(list)) return;
  const query = modal.querySelector('input[name="q"]')?.value.trim();
  if (!query) return;
  const loader = document.createElement('div');
  loader.className = 'rr-search-more';
  loader.setAttribute('role', 'status');
  loader.setAttribute('aria-live', 'polite');
  loader.innerHTML = '<span class="rr-search-more__dots" aria-hidden="true"><i></i><i></i></span><span class="visually-hidden">Loading more products</span>';
  list.after(loader);
  const state = {page:1, busy:false, done:false, controller:new AbortController(), observer:null};
  states.set(list, state);
  const current = () => list.isConnected && modal.querySelector('input[name="q"]')?.value.trim() === query;
  const key = link => new URL(link.href, location.origin).pathname;
  const seen = new Set([...list.querySelectorAll('a[href*="/products/"]')].map(key));
  const load = async () => {
   if (state.busy || state.done || !current()) return;
   state.busy = true;
   loader.classList.add('is-loading');
   list.setAttribute('aria-busy','true');
   try {
    let added = 0;
    do {
     const url = new URL(window.routes?.search_url || '/search', location.origin);
     url.search = new URLSearchParams({q:query,type:'product','options[prefix]':'last','options[unavailable_products]':'last','options[fields]':'title,product_type,variants.title,tag',section_id:'reef-search-more',page:String(state.page)});
     const response = await fetch(url, {signal:state.controller.signal});
     if (!response.ok) throw new Error('Search continuation failed');
     const doc = new DOMParser().parseFromString(await response.text(),'text/html');
     const page = doc.querySelector('[data-rr-search-page]');
     if (!page) throw new Error('Search continuation unavailable');
     if (!current()) return;
     const fragment = document.createDocumentFragment();
     page.querySelectorAll('ul > li.predictive-search__list-item').forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link || seen.has(key(link))) return;
      seen.add(key(link));
      fragment.append(item);
      added++;
     });
     list.append(fragment);
     const next = Number(page.dataset.nextPage);
     state.done = !next;
     if (next) state.page = next;
    } while (!added && !state.done && current());
    window.ValoraieHydrateProductCards?.(list);
    if (state.done) { loader.remove(); state.observer.disconnect(); }
   } catch(error) {
    if (error.name !== 'AbortError' && current()) {
     loader.innerHTML = '<button type="button">Retry loading more products</button>';
     loader.querySelector('button').addEventListener('click',load,{once:true});
     state.observer.disconnect();
    }
   } finally {
    state.busy = false;
    loader.classList.remove('is-loading');
    list.removeAttribute('aria-busy');
   }
  };
  state.observer = new IntersectionObserver(entries => {
   if (!current()) { state.controller.abort(); state.observer.disconnect(); return; }
   if (entries.some(entry => entry.isIntersecting)) load();
  },{rootMargin:'0px 0px 100px 0px'});
  state.observer.observe(loader);
  modal.querySelector('input[name="q"]')?.addEventListener('input',() => {
   if (current()) return;
   state.controller.abort(); state.observer.disconnect(); loader.remove();
  },{once:true});
 };
 document.querySelectorAll('.search-modal').forEach(modal => {
  new MutationObserver(() => setup(modal)).observe(modal,{childList:true,subtree:true});
  setup(modal);
 });
})();
